/* Read the current Shopify policy HTML; preserve its wording, markup and authored IDs. */
if (!customElements.get('evolved-legal-policy')) {
  customElements.define('evolved-legal-policy', class extends HTMLElement {
    connectedCallback() {
      this.initialize = () => {
        if (!this.isConnected || this.toc) return;
        const container = [...this.parentElement.children].find(node => node.classList.contains('shopify-policy__container'));
        const body = container?.querySelector('.shopify-policy__body');
        if (!body || container.querySelector('.ev-legal-toc')) return;

        const title = container.querySelector('.shopify-policy__title h1')?.textContent.trim().toLowerCase();
        const candidates = [...body.querySelectorAll('h2,h3')].filter(heading => {
          const label = heading.textContent.trim();
          if (label.toLowerCase() === title) {
            heading.classList.add('ev-legal-duplicate-title');
            return false;
          }
          return label && label.toLowerCase() !== 'at a glance';
        });
        const mainHeadings = candidates.filter(heading => heading.tagName === 'H2');
        const headings = mainHeadings.length ? mainHeadings : candidates;

        // Backend-authored section navigation takes precedence; never add a second menu.
        const backendNavigation = [...body.querySelectorAll('nav')].some(nav =>
          [...nav.querySelectorAll('a[href^="#"]')].filter(link => {
            const target = document.getElementById(link.getAttribute('href').slice(1));
            return target && body.contains(target);
          }).length > 1
        );
        if (backendNavigation || headings.length < 2) return;

        const details = document.createElement('details');
        details.className = 'ev-legal-toc';
        const summary = document.createElement('summary');
        summary.textContent = this.dataset.tocLabel || 'On this page';
        const nav = document.createElement('nav');
        nav.setAttribute('aria-label', summary.textContent);
        const list = document.createElement('ol');
        const policyName = location.pathname.split('/').filter(Boolean).pop();

        headings.forEach((heading, index) => {
          if (!heading.id || document.getElementById(heading.id) !== heading) {
            const slug = heading.textContent.trim().replace(/^\d+\.\s*/, '').toLowerCase()
              .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
              .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
            const base = `ev-legal-${policyName}-${slug}`;
            let id = base;
            let suffix = 2;
            while (document.getElementById(id)) id = `${base}-${suffix++}`;
            heading.id = id;
          }
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${heading.id}`;
          a.textContent = heading.textContent.trim();
          li.append(a);
          list.append(li);
        });
        nav.append(list);
        details.append(summary, nav);
        container.insertBefore(details, body);
        container.classList.add('ev-legal-has-toc');
        this.toc = details;
        this.container = container;
        this.breakpoint = matchMedia('(min-width:1000px)');
        this.syncBreakpoint = () => { details.open = this.breakpoint.matches; };
        this.syncBreakpoint();
        this.breakpoint.addEventListener('change', this.syncBreakpoint);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.initialize, {once: true});
      else this.initialize();
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.initialize);
      this.breakpoint?.removeEventListener('change', this.syncBreakpoint);
      this.toc?.remove();
      this.container?.classList.remove('ev-legal-has-toc');
      this.toc = null;
    }
  });
}
